export enum CommunicationMessageType {
    SWITCH_MESSAGE = "switchMessage",
    FINALIZE_SWITCH_MESSAGE = "finalizeSwitchMessage",
    LIVEKIT_INVITATION_MESSAGE = "livekitInvitationMessage",
    LIVEKIT_DISCONNECT_MESSAGE = "livekitDisconnectMessage",
    RECORDING_UNEXPECTEDLY_STOPPED_MESSAGE = "recordingUnexpectedlyStoppedMessage",
}
